<template>
  <div class="page">
    <img
      src="@/assets/images/login.svg"
      class="image">

    <panel class="panel">
      <h1>{{ $tc('auth.login') }}</h1>
      <el-form
        :model="form"
        label-width="0">
        <main-input v-model="form.email" :label="$tc('form.email')" :validator="$v.form.email" />
        <main-input v-model="form.password" type="password" :label="$tc('form.password')" :validator="$v.form.password" show-password />
      </el-form>

      <el-button
        class="button"
        type="primary"
        round
        @click="login()">
        {{ $tc('auth.sign_in') }}
      </el-button>

      <router-link
        :to="{ name: 'Register' }"
        class="link">
        {{ $tc('auth.no_account_register') }}
      </router-link>

      <router-link
        :to="{ name: 'ForgotPassword' }"
        class="link">
        {{ $tc('auth.forgot_password') }}
      </router-link>
    </panel>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        email: null,
        password: null
      }
    }
  },

  created () {
    this.$store.commit('app/set', {
      title: this.$tc('auth.login')
    })
  },

  methods: {
    async login () {
      if (this.$v.form.$invalid) return
      const loading = this.$loading()
      try {
        await this.$store.dispatch('auth/login', this.form)
        await this.$store.dispatch('app/loadData')
        this.$router.push({ name: 'Home' })
        this.$message.success(this.$tc('messages.success_sign_in'))
      } catch (error) {
        this.$message.error(error.response.data.error ?? this.$tc('messages.error_email_password_combination'))
      } finally {
        loading.close()
      }
    }
  },

  validations: {
    form: {
      email: { required },
      password: { required }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .image {
    width: 500px;
    margin-right: 150px;
  }
  .panel {
    width: 500px;
    padding: 30px 50px;

    .button {
      margin-top: 30px;
      width: 100%;
      height: 50px;
      border-radius: 9999px;
    }
    .link {
      display: block;
      text-align: center;
      margin-top: 20px;
      font-size: 17px;
      color: $dark;
    }
  }
}

@media (max-width: 600px) {
  .page .image {
    margin: 0;
    width: 100%;
  }
}
</style>
